import axios from '@axios';

const userTokenKey = 'userTokenPost'; // changed keys as they clashed with portal names locally (used in router also)
const userRefreshTokenKey = 'userRefreshTokenPost';
const userKey = 'userPost';
export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    getLocalUser() {
      return JSON.parse(localStorage.getItem(userKey));
    },
    getLocalUserToken() {
      return localStorage.getItem(userTokenKey);
    },
    getLocalUserRefreshToken() {
      return localStorage.getItem(userRefreshTokenKey);
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
  },
  actions: {
    // eslint-disable-next-line
    clearLocalUser({ commit }) {
      localStorage.removeItem(userTokenKey);
      localStorage.removeItem(userRefreshTokenKey);
      localStorage.removeItem(userKey);
      axios.defaults.headers.common.Authorization = null;
    },
    // eslint-disable-next-line
    setLocalUser({ commit }, user) {
      localStorage.setItem(userKey, JSON.stringify(user));
      commit('SET_USER', user);
    },
    // eslint-disable-next-line
    setLocalUserToken({ commit }, token) {
      localStorage.setItem(userTokenKey, token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      // console.log('token set', axios.defaults.headers.common.Authorization);
    },
    // eslint-disable-next-line
    setLocalUserRefreshToken({ commit }, token) {
      localStorage.setItem(userRefreshTokenKey, token);
    },
    setCurrentUserFromLocalStorage({ commit }) {
      const user = localStorage.getItem(userKey);

      if (user) {
        commit('SET_USER', JSON.parse(user));
      }
    },
  },
};
